import React, { useState, useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import { RemoveAttributRow, updateAttributRow } from "../../../../redux/actions/createGridAttribut";

import deleteItem from "../../../../assets/images/delete-icon.svg";

import "./style.css";


const AttributRows = ({ item }) => {
  const dispatch = useDispatch();
  const { attributsByPerimetre, attributsByPerimetreSelect } = useSelector((state) => state.attribut);
  const { attributesRow } = useSelector((state) => state.createGridAttribut);

  const [selectedAttribut, setSelectedAttribut] = useState({
    value: item.attributId ? item.attributId : null,
    label: item.attribut ? item.attribut : null,
  });
  const [optionsValues, setOptionsValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState(item.values ? item.values.filter(value => value.status == true) : []);
  const [previousSelectedAttribut , setPreviousSelectedAttribut] = useState(attributsByPerimetreSelect);

  useEffect(() => {
    let newArry = attributsByPerimetre.filter((item) => item.id === selectedAttribut.value);
    let op = newArry[0]?.ValeurAttribut?.filter((val)=> val.status == true).map((val) => {
       return { attributId: newArry[0].id, value: val.id, label: val.name, status : val.status};
    });
    setOptionsValues(op);
  }, [selectedAttribut.value, attributsByPerimetre]);

  useEffect(() => {
    if (selectedAttribut.value) {
      dispatch(updateAttributRow(item.attributesIndex, selectedAttribut.label, selectedValues , selectedAttribut.value));
    } 
  }, [selectedAttribut.value, selectedValues]);

  useEffect(()=>{
    // Create an array of labels from the attributesRow array
    const labels = attributesRow.map(item => item?.attributId);
    // Find the elements in the attributsByPerimetreSelect array that do not match any of the labels in the labels array
    const diffArr =  attributsByPerimetreSelect.filter(item => {
     return  !labels.includes(item?.value)
    });

    setPreviousSelectedAttribut(diffArr);
    },[attributesRow])

  return (
  
      <Row className="marginRows" style={{ padding: "0 24px 20px" }}>
        <Col xs={12} md={5}>
          <Select
            placeholder="Attributs"
            defaultValue={item.attribut ? { value: item.attributId, label: item.attribut } : null}
            options={previousSelectedAttribut}
            onChange={(option)=> {
              setSelectedAttribut(option);
              setSelectedValues([]);
            }}
          />
        </Col>
        <Col xs={12} md={6}>
          <Select
            key={selectedAttribut?.value}
            placeholder="Valeurs"
            isMulti
            isClearable={false}
            closeMenuOnSelect={false}
            defaultValue={selectedValues}
            options={optionsValues}
            onChange={setSelectedValues}
          />
        </Col>
        <Col xs={12} md={1} className="delete-item-col">
          <img
            key={item.attributesIndex}
            src={deleteItem}
            alt="deleteItem"
            style={{ cursor: "pointer" , width:"32px" }}
            onClick={() => dispatch(RemoveAttributRow(item.attributesIndex))}
          />
        </Col>
      </Row>
  
  );
};

export default AttributRows;
